import { AppData, BookingData, Step } from "../../AppDataProvider";

import { CompleteResourcesStepPayload } from "../../actions";
import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "../../../utils/types";
import { requireBookingDataFields } from "../../../utils/requireBookingDataFields/requireBookingDataFields";

export type CompleteResourcesStepOpts = {
  appData: AppData;
  payload: CompleteResourcesStepPayload;
};

export const completeResourcesStep = (
  options: CompleteResourcesStepOpts,
): AppData => {
  if (
    options.payload.updatedData === null ||
    (!options.payload.updatedData.resource &&
      !options.payload.updatedData.resourceGroupId)
  ) {
    Mixpanel.track({
      name: "Completed step",
      props: { selectionType: "ANY", step: "resources" },
    });
  } else {
    const { resource, resourceGroupId } = options.payload.updatedData;
    if (resource) {
      Mixpanel.track({
        name: "Completed step",
        props: {
          selectedResource: { id: resource._id, name: resource.name },
          selectionType: "RESOURCE",
          step: "resources",
        },
      });
    } else {
      Mixpanel.track({
        name: "Completed step",
        props: {
          // If resource not in payload, resourceGroupId definitely exists
          selectedResourceGroup: { id: resourceGroupId as string },
          selectionType: "GROUP",
          step: "resources",
        },
      });
    }
  }

  const { bookingData } = options.appData;

  requireBookingDataFields<
    PartRequired<BookingData, "organisation" | "service">
  >(bookingData, ["organisation", "service"]);

  const { organisation, service } = bookingData;

  const {
    allowBookingNotes,
    resourceSelectionBeforeAvailability,
    externalBookingQuestions,
  } = organisation;

  const hasRelevantBookingQuestions = externalBookingQuestions.some(
    (question) =>
      !question.services ||
      question.services.map(({ _id }) => _id).includes(service._id),
  );

  const nextStep: Step = resourceSelectionBeforeAvailability
    ? "availability"
    : hasRelevantBookingQuestions || allowBookingNotes
    ? "bookingQuestions"
    : "details";

  const updatedBookingData = {
    ...bookingData,
    ...(options.payload.updatedData === null
      ? { resource: undefined }
      : { ...options.payload.updatedData }),
  };

  return {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: nextStep,
  };
};
